'use-strict';

/* @ngInject */
export default function MonitoringTaskTableController(
  $scope,
  $location,
  NgTableParams,
  interfaceService,
  taskModel,
) {
  const self = this;
  $scope.allTasks = null;
  $scope.createdTasks = null;
  $scope.openTasks = null;

  $scope.commentDialogId = null;

  $scope.filter = {
    taskFilter: '',
    vehicleFilter: '',
    state: '',
  };
  $scope.filterOptions = {
    state: {
      open: 'Offen',
      closed: 'Geschlossen',
      overdue: 'Überfällig',
    },
  };

  /**
   * Change route to task form.
   * @param {number} taskId
   */
  $scope.taskClick = (taskId) => {
    $location.path(`/tasks/task/${taskId}`);
  };

  $scope.showCommentDialog = (taskId) => {
    $scope.commentDialogId = taskId;
  };

  $scope.hideCommentDialog = () => {
    $scope.commentDialogId = null;
  };

  /**
   * Update the view's table with the provided data.
   * @param {Array<object>} data
   */
  const updateTableData = (table, data) => {
    table.settings({
      dataset: data,
    });
    interfaceService.applyScope($scope);
  };

  /**
   * Get all `Tasks` assigned to current user that are marked as `open`.
   */
  const getOpenTasks = () => {
    taskModel.getAllOpen()
      .then((tasks) => {
        $scope.openTasks = tasks;
        console.log(tasks);
        updateTableData(self.openTaskTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getCreatedTasks = () => {
    taskModel.getAllCreated()
      .then((tasks) => {
        $scope.createdTasks = tasks;
        updateTableData(self.createdTasksTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getAllTasks = () => {
    taskModel.getAll()
      .then((tasks) => {
        $scope.allTasks = tasks;
        updateTableData(self.allTasksTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  $scope.changeRailItem = (item) => {
    if (item === 'Alle') getAllTasks();
    if (item === 'Erstellt') getCreatedTasks();
  };

  const init = () => {
    self.openTaskTable = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    self.createdTasksTable = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    self.allTasksTable = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    getOpenTasks();
  };

  /** Fix for `changeFunction` of `ab-select` component
   * being applied with a delay. */
  $scope.setStateFilter = () => {
    setTimeout(() => {
      self.openTaskTable.filter().state = $scope.filter.state;
      self.allTasksTable.filter().state = $scope.filter.state;
      self.createdTasksTable.filter().state = $scope.filter.state;
    }, 100);
  };

  init();
}
